(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legumi-discount-popup"] && !Shopify.designMode) return;
  try {
    const popup = document.getElementById('legumi-discount-popup');
  if (popup && popup.dataset.pageType === 'index' && !document.documentElement.classList.contains('shopify-design-mode')) {
    let seen = false;
    try { seen = sessionStorage.getItem('legumi10-popup-seen') === '1'; } catch {}
    if (!seen && typeof popup.showModal === 'function') {
      let observer;
      let displayed = false;
      const show = () => {
        if (displayed) return;
        const cookieBanner = document.getElementById('shopify-pc__banner');
        if (cookieBanner && cookieBanner.getClientRects().length) return;
        displayed = true;
        popup.showModal();
        try { sessionStorage.setItem('legumi10-popup-seen', '1'); } catch {}
        observer?.disconnect();
      };
      const startDelay = () => {
        const navigation = performance.getEntriesByType('navigation')[0];
        const elapsed = navigation?.loadEventEnd > 0 ? performance.now() - navigation.loadEventEnd : 0;
        window.setTimeout(() => {
          observer = new MutationObserver(show);
          observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
          show();
        }, Math.max(0, 5000 - elapsed));
      };
      if (document.readyState === 'complete') {
        startDelay();
      } else {
        window.addEventListener('load', startDelay, { once: true });
      }
    }
    popup.querySelectorAll('[data-discount-close]').forEach(button => button.addEventListener('click', () => popup.close()));
    popup.addEventListener('click', event => {
      if (event.target !== popup) return;
      const rect = popup.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) popup.close();
    });
    popup.querySelector('[data-discount-copy]').addEventListener('click', async event => {
      const button = event.currentTarget;
      const status = popup.querySelector('[data-discount-status]');
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText('LEGUMI10');
          copied = true;
        }
      } catch {}
      if (!copied) {
        const field = document.createElement('textarea');
        field.value = 'LEGUMI10';
        field.setAttribute('readonly', '');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        popup.appendChild(field);
        field.select();
        field.setSelectionRange(0, field.value.length);
        try { copied = document.execCommand('copy'); } catch {}
        field.remove();
        button.focus({ preventScroll: true });
      }
      status.textContent = copied ? popup.dataset.success : popup.dataset.error;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
